// extracted by mini-css-extract-plugin
export default {"root":"Confirm_root__vqPYQ","progress":"Confirm_progress__WXRQ1"};